export default __webpack_public_path__ + "static/media/chat2.68a1b4bb.svg";